import React from "react"
import {useTranslation} from "react-i18next"
import {Box, Typography} from "@mui/material"
import {ReactComponent as DefaultHeader} from "../../icon/default-header.svg"
import {ReactComponent as Exclamation} from "../../icon/exclamation.svg"
import BobbingIcon from "../common/BobbingIcon"

interface PageNotFoundProps {
  error?: string | null
}

function PageNotFound({error}: PageNotFoundProps) {
  const {t} = useTranslation()

  return (
    <Box
      sx={{
        textAlign: "center",
        mt: "70px",
        "@media (max-width: 520px)": {
          mt: "20px",
          px: "20px",
        },
      }}
    >
      <Box>
        <Box
          component="a"
          href="https://www.simplebooth.com"
          target="_top"
        >
          <Box
            component={DefaultHeader}
            sx={{
              fill: "#403f3f",
              mt: "40px",
              px: "20px",
              maxWidth: 434,
            }}
          />
        </Box>
      </Box>

      <Box sx={{mt: "90px"}}>
        <BobbingIcon
          horizontalOffset="-23px"
          verticalOffset="-20px"
        >
          <Exclamation/>
        </BobbingIcon>
      </Box>

      <Typography
        component="h1"
        sx={{
          color: "#323232",
          fontSize: "28.64px",
          fontWeight: 300,
          mt: "90px",
          "@media (max-width: 520px)": {
            mt: "30px",
          },
        }}
      >
        {t("pageNotFound.heading")}{" "}
        <span role="img" aria-label="Sad face">😔</span>
      </Typography>
      {error && (
        <Typography
          component="p"
          sx={{
            color: "#323232",
            fontSize: "19px",
            fontWeight: 300,
          }}
        >
          ({error})
        </Typography>
      )}
    </Box>
  )
}

export default PageNotFound
